export default __webpack_public_path__ + "static/slider7-7210a942de88116c29403bc74cf12ba1.jpg";